
import React from 'react';
import './index.css';

CityItem.defaultProps = {
  actionType: 'circle-add' // 可选 circle-arrow ， circle-add
};

export default function CityItem(props){
  let { clickCityItem, city, type, actionType } = props;

  let isSearchCity = type === 'search' ? true : false;
  let image = (city.pic && city.pic.small_s) || city.pic_url || 'http://poi-img.tantu.com/city_pic/7991.jpg!/both/180x140';
  return(
    <div className="city-item" onClick={(e)=>{
      if (actionType !== 'arrow') {
        return;
      }
      clickCityItem(e, city, actionType);
    }}>
      <div className="city-detail">
        <div className="image">
          {
            city.is_customs === '1'
              ? (<div className="tag"><span>出入境口岸</span></div>)
              : null
          }
          <img src={image} alt="城市图片"/>
        </div>
        {isSearchCity ? <SearchCityDetail city={city} /> : <CityDetail city={city}/> }
      </div>
      <div className={`city-action ${actionType}`} onClick={(e)=>{
        e.stopPropagation();
        clickCityItem(e, city, actionType);
      }}>
        <span className="label">
          <i className={`icon icon-${actionType ? actionType : 'circle-add'}`}></i>
        </span>
      </div>
    </div>
  );
}



/**
 * 列表项城市显示
 * @param {*} props 
 */
function CityDetail(props){
  let {city} = props;

  return(
    <div className="detail">
      <h3 className="name">{city.cn_name}</h3>
      <p className="day">建议玩 <em>{city.play_day}</em>天</p>
      <ul className="hot-pois clearfix">
        {city.poi_list.map(function (poi) {
          return (<li key={poi.poi_uid}><p>{poi.cn_name}</p></li>);
        })}
      </ul>
    </div>
  );
}

/**
 * 搜索时城市项显示
 * @param {*} props 
 */
function SearchCityDetail(props){
  let {city} = props;

  return(
    <div className="detail">
      <h3 className="name">{city.cn_name || city.region_cn}</h3>
      <p className="en-name">{city.en_name || city.region_en}</p>
      <p className="region">{city.ascription_cn}</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/City/index.js